import {NavigationComponent} from '../../components/navigation/navigation.component';
import {Card} from 'primereact/card';

import styles from './download.module.css';
import {clsx} from 'clsx';
import {centerOfScreen} from '../../styles/prime-flex-classes.constants';
import {useNavigate, useParams} from 'react-router-dom';
import {Button} from 'primereact/button';
import React, {useEffect} from 'react';

const DownloadPage = () => {
  const navigate = useNavigate();
  const { '*' : path } = useParams();
  const href = `${process.env.REACT_APP_HOST}/download/${path}`;

  useEffect(() => {
    const link = document.createElement('a');
    link.href = href;
    link.click();
  })

  return (
    <>
      <div
        className={'min-h-screen'}
        style={{
          backgroundImage: 'url(images/carousel04_min.jpg)',
          backgroundSize: 'cover',
        }}
      >
        <NavigationComponent/>
        <div
          className={clsx('flex m-9', centerOfScreen)}
        >
          <Card
            title={'Скачивание файла'}
            subTitle={path}
            pt={{
              root: {
                className: styles['card_error__wrapper'],
              },
            }}
            footer={<Button icon={'pi pi-home'} label={'В начало'} onClick={() => navigate('/')}/>}
          >
            <div
              className="flex flex-row justify-content-center align-items-center"
            >
              <span>Если скачивание не началось, кликните по</span>
              <Button
                label="ссылке"
                onClick={() => window.open(path, '_blank')}
                icon="pi pi-link"
                rounded
                text
                aria-label="Filter"
              />
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}

export default DownloadPage;